import { library, config } from '@fortawesome/fontawesome-svg-core';
// eslint-disable-next-line import-x/extensions
import '@fortawesome/fontawesome-svg-core/styles.css'; // This adds the basic icon styles into your app
import { faCalendar } from '@fortawesome/free-regular-svg-icons/faCalendar';
import { faCircle as faCircleFar } from '@fortawesome/free-regular-svg-icons/faCircle';
import { faSquare } from '@fortawesome/free-regular-svg-icons/faSquare';
import { faClock } from '@fortawesome/free-regular-svg-icons/faClock';
import { faListCheck } from '@fortawesome/pro-solid-svg-icons/faListCheck';
import { faArrowDownShortWide } from '@fortawesome/pro-solid-svg-icons/faArrowDownShortWide';
import { faInbox } from '@fortawesome/pro-solid-svg-icons/faInbox';
import { faCircleCheck } from '@fortawesome/pro-solid-svg-icons/faCircleCheck';
import { faShuffle } from '@fortawesome/pro-solid-svg-icons/faShuffle';
import { faBullseyePointer } from '@fortawesome/pro-solid-svg-icons/faBullseyePointer';
import { faPaperPlane } from '@fortawesome/pro-solid-svg-icons/faPaperPlane';
import { faFileSpreadsheet } from '@fortawesome/pro-solid-svg-icons/faFileSpreadsheet';
import { faChartMixed } from '@fortawesome/pro-solid-svg-icons/faChartMixed';
import { faBell } from '@fortawesome/pro-solid-svg-icons/faBell';
import { faPlug } from '@fortawesome/pro-solid-svg-icons/faPlug';
import { faGear } from '@fortawesome/pro-solid-svg-icons/faGear';
import { faCloudPlus } from '@fortawesome/pro-solid-svg-icons/faCloudPlus';
import { faCloudArrowDown } from '@fortawesome/pro-solid-svg-icons/faCloudArrowDown';
import { faArrowUp } from '@fortawesome/pro-solid-svg-icons/faArrowUp';
import { faArrowDown } from '@fortawesome/pro-solid-svg-icons/faArrowDown';
import { faArrowRight } from '@fortawesome/pro-solid-svg-icons/faArrowRight';
import { faLocationPlus } from '@fortawesome/pro-solid-svg-icons/faLocationPlus';
import { faUserGroup } from '@fortawesome/pro-solid-svg-icons/faUserGroup';
import { faCreditCardFront } from '@fortawesome/pro-solid-svg-icons/faCreditCardFront';
import { faGift } from '@fortawesome/pro-solid-svg-icons/faGift';
import { faGauge } from '@fortawesome/pro-solid-svg-icons/faGauge';
import { faAddressCard } from '@fortawesome/pro-solid-svg-icons/faAddressCard';
import { faXmark } from '@fortawesome/pro-solid-svg-icons/faXmark';
import { faMagnifyingGlass } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlass';
import { faChevronDown } from '@fortawesome/pro-solid-svg-icons/faChevronDown';
import { faEyeSlash } from '@fortawesome/pro-solid-svg-icons/faEyeSlash';
import { faArrowsRotate } from '@fortawesome/pro-solid-svg-icons/faArrowsRotate';
import { faTrash } from '@fortawesome/pro-solid-svg-icons/faTrash';
import { faPen } from '@fortawesome/pro-solid-svg-icons/faPen';
import { faMagnifyingGlassPlus } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassPlus';
import { faMagnifyingGlassMinus } from '@fortawesome/pro-solid-svg-icons/faMagnifyingGlassMinus';
import { faUnlock } from '@fortawesome/pro-solid-svg-icons/faUnlock';
import { faCircleQuestion } from '@fortawesome/pro-solid-svg-icons/faCircleQuestion';
import { faPlus } from '@fortawesome/pro-solid-svg-icons/faPlus';
import { faBolt } from '@fortawesome/pro-solid-svg-icons/faBolt';
import { faQuestionCircle } from '@fortawesome/pro-solid-svg-icons/faQuestionCircle';
import { faExternalLinkSquare } from '@fortawesome/pro-solid-svg-icons/faExternalLinkSquare';
import { faCircleInfo } from '@fortawesome/pro-solid-svg-icons/faCircleInfo';
import { faLoader } from '@fortawesome/pro-solid-svg-icons/faLoader';
import { faChevronRight } from '@fortawesome/pro-solid-svg-icons/faChevronRight';
import { faChevronLeft } from '@fortawesome/pro-solid-svg-icons/faChevronLeft';
import { faEnvelope } from '@fortawesome/pro-solid-svg-icons/faEnvelope';
import { faEnvelopeOpen } from '@fortawesome/pro-solid-svg-icons/faEnvelopeOpen';
import { faSave } from '@fortawesome/pro-solid-svg-icons/faSave';
import { faFloppyDiskPen } from '@fortawesome/pro-solid-svg-icons/faFloppyDiskPen';
import { faFilter } from '@fortawesome/pro-solid-svg-icons/faFilter';
import { faUpload } from '@fortawesome/pro-solid-svg-icons/faUpload';
import { faTriangleExclamation } from '@fortawesome/pro-solid-svg-icons/faTriangleExclamation';
import { faCertificate } from '@fortawesome/pro-solid-svg-icons/faCertificate';
import { faClone } from '@fortawesome/pro-solid-svg-icons/faClone';
import { faRefresh } from '@fortawesome/pro-solid-svg-icons/faRefresh';
import { faArrowTrendUp } from '@fortawesome/pro-solid-svg-icons/faArrowTrendUp';
import { faLink } from '@fortawesome/pro-solid-svg-icons/faLink';
import { faChainBroken } from '@fortawesome/pro-solid-svg-icons/faChainBroken';
import { faCloudDownload } from '@fortawesome/pro-solid-svg-icons/faCloudDownload';
import { faMoneyBill } from '@fortawesome/pro-solid-svg-icons/faMoneyBill';
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons/faExclamationCircle';
import { faPercent } from '@fortawesome/pro-solid-svg-icons/faPercent';
import { faCircle as faCircleFas } from '@fortawesome/pro-solid-svg-icons/faCircle';
import { faPowerOff } from '@fortawesome/pro-solid-svg-icons/faPowerOff';
import { faStar } from '@fortawesome/pro-solid-svg-icons/faStar';
import { faThumbsDown } from '@fortawesome/pro-solid-svg-icons/faThumbsDown';
import { faThumbsUp } from '@fortawesome/pro-solid-svg-icons/faThumbsUp';
import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons/faCircleNotch';
import { faCaretRight } from '@fortawesome/pro-solid-svg-icons/faCaretRight';
import { faArrowRotateLeft } from '@fortawesome/pro-solid-svg-icons/faArrowRotateLeft';
import { faSort } from '@fortawesome/pro-solid-svg-icons/faSort';
import { faSortUp } from '@fortawesome/pro-solid-svg-icons/faSortUp';
import { faSortDown } from '@fortawesome/pro-solid-svg-icons/faSortDown';
import { faPhone } from '@fortawesome/pro-solid-svg-icons/faPhone';
import { faMoon } from '@fortawesome/pro-solid-svg-icons/faMoon';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { faFloppyDisk } from '@fortawesome/pro-solid-svg-icons/faFloppyDisk';
import { faCommentDots } from '@fortawesome/pro-solid-svg-icons/faCommentDots';
import { faComments } from '@fortawesome/pro-solid-svg-icons/faComments';
import { faFileLines } from '@fortawesome/pro-solid-svg-icons/faFileLines';
import { faFileImage } from '@fortawesome/pro-solid-svg-icons/faFileImage';
import { faCircleXmark } from '@fortawesome/pro-solid-svg-icons/faCircleXmark';
import { faAngleLeft } from '@fortawesome/pro-solid-svg-icons/faAngleLeft';
import { faSquarePen } from '@fortawesome/pro-solid-svg-icons/faSquarePen';
import { faSquareMinus } from '@fortawesome/pro-solid-svg-icons/faSquareMinus';
import { faHome } from '@fortawesome/pro-solid-svg-icons/faHome';
import { faBed } from '@fortawesome/pro-solid-svg-icons/faBed';
import { faBath } from '@fortawesome/pro-solid-svg-icons/faBath';
import { faCheck } from '@fortawesome/pro-solid-svg-icons/faCheck';
import { faLightbulb } from '@fortawesome/pro-solid-svg-icons/faLightbulb';
import { faFile } from '@fortawesome/pro-solid-svg-icons/faFile';
import { faBuildingMemo } from '@fortawesome/pro-solid-svg-icons/faBuildingMemo';
import { faGlobe } from '@fortawesome/pro-solid-svg-icons/faGlobe';
import { faPartyHorn } from '@fortawesome/pro-solid-svg-icons/faPartyHorn';
import { faReply } from '@fortawesome/pro-solid-svg-icons/faReply';

// Disable auto CSS import into head. It solved the side effect for jumping icon size.
// This is required for Fastboot apps, otherwise build fails
// It's the recommended way for setup Font Awesome in your app
config.autoAddCss = false;

// option to import all icons from solid pack.
// If you want to import only a subset of icons from pack, see section 'Subsetting icons'
library.add(
  // far icons
  faCalendar,
  faCircleFar,
  faSquare,
  faClock,

  // fas icons
  faInbox,
  faCircleCheck,
  faShuffle,
  faBullseyePointer,
  faPaperPlane,
  faFileSpreadsheet,
  faChartMixed,
  faBell,
  faPlug,
  faGear,
  faCloudPlus,
  faCloudArrowDown,
  faArrowUp,
  faArrowDown,
  faArrowRight,
  faLocationPlus,
  faUserGroup,
  faCreditCardFront,
  faGift,
  faGauge,
  faAddressCard,
  faXmark,
  faMagnifyingGlass,
  faChevronDown,
  faEyeSlash,
  faArrowsRotate,
  faTrash,
  faPen,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faUnlock,
  faCircleQuestion,
  faPlus,
  faBolt,
  faQuestionCircle,
  faExternalLinkSquare,
  faCircleInfo,
  faLoader,
  faChevronRight,
  faChevronLeft,
  faGear,
  faEnvelope,
  faEnvelopeOpen,
  faSave,
  faFloppyDiskPen,
  faFilter,
  faUpload,
  faTriangleExclamation,
  faTrash,
  faCertificate,
  faClone,
  faRefresh,
  faArrowTrendUp,
  faLink,
  faChainBroken,
  faCloudDownload,
  faMoneyBill,
  faExclamationCircle,
  faPercent,
  faCircleFas,
  faPowerOff,
  faStar,
  faThumbsDown,
  faThumbsUp,
  faCircleNotch,
  faCaretRight,
  faArrowRotateLeft,
  faSort,
  faSortUp,
  faSortDown,
  faPhone,
  faMoon,
  faUser,
  faFloppyDisk,
  faCommentDots,
  faComments,
  faFileLines,
  faFileImage,
  faCircleXmark,
  faAngleLeft,
  faSquarePen,
  faSquareMinus,
  faHome,
  faBed,
  faBath,
  faCheck,
  faLightbulb,
  faFile,
  faBuildingMemo,
  faGlobe,
  faPartyHorn,
  faReply,
  faListCheck,
  faArrowDownShortWide,
);
